import { useState, useEffect } from "react";
import { getSuperContainerList } from "../../../services/container";
import Cookies from "js-cookie";
/**
 * Hook pour charger la liste des super conteneurs
 */
export const useSuperContainers = () => {
  const [superContainers, setSuperContainers] = useState({});
  const API = process.env.REACT_APP_API_BACKEND;
  const token = Cookies.get("userToken");

  useEffect(() => {
    getSuperContainerList()
      .then((response) => {
        if (response.data.superContainers.length > 0) {
          setSuperContainers(response.data.superContainers);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [API, token]);

  return { superContainers };
};
